export const getPercentage = ({ total, amount }) => {
  return (Number(amount | 0) * 100) / Number(total | 0);
};
